import { render, staticRenderFns } from "./ordersFilterBox.vue?vue&type=template&id=592c8f67&"
import script from "./ordersFilterBox.vue?vue&type=script&lang=ts&"
export * from "./ordersFilterBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports